import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { PhotoLibrary as PhotoLibraryIcon } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(5),
  },

  icon: {
    fontSize: 48,
    color: '#bbb',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(2),
    display: 'block',
  },

  message: {
    color: '#999',
    textAlign: 'center',
    fontWeight: 400,
  },
}))

const EmptyPhotoLibrary = () => {
  const classes = useStyles()

  return (
    <Grid
      container
      justifyContent='center'
      alignItems='center'
      className={classes.root}
    >
      <Grid item xs={12}>
        <PhotoLibraryIcon className={classes.icon} />
        <Typography variant='h5' className={classes.message}>
          Nenhum resultado. Use a lupa acima para encontrar sua foto!
        </Typography>
      </Grid>
    </Grid>
  )
}

export default EmptyPhotoLibrary
